import { useEffect } from 'react';
import HeroSlider from './components/HeroSlider';
import StatsProprietarios from './components/StatsProprietarios';
import BenefitsSection from './components/BenefitsSection';
import TestimonialsProprietarios from './components/TestimonialsProprietarios';
import CTAProprietarios from './components/CTAProprietarios';
import FormularioProprietario from './components/FormularioProprietario';
import CalculadoraValorSection from '../home/components/CalculadoraValorSection';

const ProprietariosPage = () => {
  useEffect(() => {
    document.title = 'Expansão Patrimonial para Proprietários | Daniel Carvalho';
    const desc = document.querySelector('meta[name="description"]');
    if (desc) desc.setAttribute('content', 'Transforme seu imóvel em um ativo de alto retorno. Valuation estratégico de mercado e acesso aos mercados mais rentáveis para maximizar o valor do seu patrimônio com inteligência e segurança.');
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) canonical.setAttribute('href', `${import.meta.env.VITE_SITE_URL ?? 'https://danielcarvalhoimobiliario.com.br'}/proprietarios`);

    const siteUrl = import.meta.env.VITE_SITE_URL ?? 'https://danielcarvalhoimobiliario.com.br';
    const ogImage = 'https://static.readdy.ai/image/b38d0475ce589291eceb67661996448f/2a2558c7aa812b59f3632681c7e8edfc.png';
    const ogTitle = 'Expansão Patrimonial para Proprietários | Daniel Carvalho';
    const ogDesc = 'Transforme seu imóvel em um ativo de alto retorno. Valuation estratégico de mercado e acesso aos mercados mais rentáveis para maximizar o valor do seu patrimônio com inteligência e segurança.';

    const setMeta = (sel: string, attr: string, val: string) => {
      let el = document.querySelector(sel) as HTMLMetaElement | null;
      if (!el) { el = document.createElement('meta'); document.head.appendChild(el); }
      el.setAttribute(attr, val);
    };

    setMeta('meta[property="og:type"]', 'content', 'website');
    setMeta('meta[property="og:url"]', 'content', `${siteUrl}/proprietarios`);
    setMeta('meta[property="og:title"]', 'content', ogTitle);
    setMeta('meta[property="og:description"]', 'content', ogDesc);
    setMeta('meta[property="og:image"]', 'content', ogImage);
    setMeta('meta[property="og:image:width"]', 'content', '1200');
    setMeta('meta[property="og:image:height"]', 'content', '630');
    setMeta('meta[property="og:locale"]', 'content', 'pt_BR');
    setMeta('meta[property="og:site_name"]', 'content', 'Daniel Carvalho Serviços Imobiliários');
    setMeta('meta[name="twitter:card"]', 'content', 'summary_large_image');
    setMeta('meta[name="twitter:title"]', 'content', ogTitle);
    setMeta('meta[name="twitter:description"]', 'content', ogDesc);
    setMeta('meta[name="twitter:image"]', 'content', ogImage);

    const schemaId = 'schema-proprietarios';
    if (!document.getElementById(schemaId)) {
      const script = document.createElement('script');
      script.id = schemaId;
      script.type = 'application/ld+json';
      script.text = JSON.stringify({
        '@context': 'https://schema.org',
        '@graph': [
          {
            '@type': 'WebPage',
            name: 'Expansão Patrimonial para Proprietários – Daniel Carvalho',
            url: `${import.meta.env.VITE_SITE_URL ?? 'https://danielcarvalhoimobiliario.com.br'}/proprietarios`,
            description: 'Transforme seu imóvel em ativo de alto retorno com valuation estratégico e acesso aos mercados mais rentáveis.',
            inLanguage: 'pt-BR',
            about: {
              '@type': 'RealEstateAgent',
              name: 'Daniel Carvalho Serviços Imobiliários',
              telephone: '+55-11-92230-5730',
              areaServed: { '@type': 'City', name: 'Brasília', containedInPlace: { '@type': 'State', name: 'Distrito Federal' } }
            }
          },
          {
            '@type': 'FAQPage',
            mainEntity: [
              {
                '@type': 'Question',
                name: 'Como funciona a avaliação gratuita do meu imóvel em Brasília?',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: 'Nossa equipe realiza uma análise completa do seu imóvel em Brasília, considerando localização, metragem, estado de conservação e comparativos de mercado, sem nenhum custo para o proprietário.'
                }
              },
              {
                '@type': 'Question',
                name: 'Quanto tempo leva para vender um imóvel em Brasília?',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: 'Com nossa estratégia de divulgação premium e carteira de compradores qualificados, o tempo médio de venda de imóveis em Brasília é de 45 dias.'
                }
              },
              {
                '@type': 'Question',
                name: 'Vocês cuidam de toda a documentação para venda ou aluguel?',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: 'Sim! Oferecemos suporte jurídico completo, desde a análise de documentação até a assinatura do contrato, garantindo total segurança para o proprietário.'
                }
              }
            ]
          }
        ]
      });
      document.head.appendChild(script);
    }

    return () => {
      const el = document.getElementById(schemaId);
      if (el) el.remove();
    };
  }, []);

  return (
    <main className="min-h-screen">
      <HeroSlider />
      <StatsProprietarios />
      <BenefitsSection />
      <TestimonialsProprietarios />
      <CTAProprietarios />
      <CalculadoraValorSection showCTA={true} ctaVariant="below" />
      <FormularioProprietario />
    </main>
  );
};

export default ProprietariosPage;
